import {Component} from '@angular/core';

@Component({
  selector: 'mc-tooltip-panel-wrapper',
  templateUrl: './tooltip-panel-wrapper.component.html',
  styleUrls: ['./tooltip-panel-wrapper.component.scss'],
  standalone: true,
})
export class TooltipPanelWrapperComponent {}
